export enum ReservationRolesEnum {
  Basic = 'Basic',
  Advanced = 'Advanced',
  Approver = 'Approver',
  Validator = 'Validator',
  None = 'None',
}
